"use client";

import ManagementSubscriptionContext from "./ManagementSubscriptionContext";
import ManagementSubscription from "./page-content";
import { ToastProvider } from "../../components/ToastNotification/toastProvider";

export default function ManagementSubscriptionPage() {
  return (
    <ManagementSubscriptionContext>
      <ManagementSubscription />
      <ToastProvider />
    </ManagementSubscriptionContext>
  );
}
